import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  buyHelper,
  getComuni,
  getNazioni,
  newComuni,
  newNazioni,
  reroute,
} from '../../../actions/Buy'
import {
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackCittadinanza,
} from '../../../actions/buy/Compass'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import { getSelectedFinanziamento } from '../../../utils/findomesticUtils'
import { isNlt, isNltBrumbrum } from '../../../utils/nltUtils'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import MiniCartNlt from '../../noleggia/dumb/MinicartNlt'
import NoleggiaBrumbrumDataForm from '../../noleggia/smart/NoleggiaBrumbrumDataForm'
import NoleggiaDataForm from '../../noleggia/smart/NoleggiaDataForm'
import BuyHelpBank from '../dumb/BuyHelpBank'
import BuyHelpFinancement from '../dumb/BuyHelpFinancement'
import BuyMiniCart from '../dumb/BuyMiniCart'
import { preparaValoriLogistica } from '../utils'
import BuyDataFormBank from './BuyDataFormBank'
import BuyDataFormFinancement from './BuyDataFormFinancement'
import BuyDataFormFindomestic from './BuyDataFormFindomestic'

class Data extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEECTracked: false,
    }
    this.handleHelper = this.handleHelper.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    if (
      !('comune' in this.props.comuni) ||
      this.props.comuni.comune === null ||
      this.props.comuni.comune.length === 0
    ) {
      this.props
        .getComuni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/comune`,
          method: 'GET',
          callback: this.props.newComuni,
        })
        .catch(() => null)
    }

    if (
      !('nazione' in this.props.comuni) ||
      this.props.comuni.nazione === null ||
      this.props.comuni.nazione.length === 0
    ) {
      this.props
        .getNazioni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/nazioni/complete/all`,
          method: 'GET',
          callback: this.props.newNazioni,
        })
        .catch(() => null)
    }

    if (!this.state.isEECTracked && isNlt(this.props.product.linea_prodotto)) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
                nlt: this.props.nlt,
              },
              3
            )
            .then(() => {})
      )
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    for (const key in nextProps) {
      if (key === 'customer' || key === 'compass_tabelledominio') {
        continue
      } else if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  handleHelper() {
    this.props.buyHelper()
  }

  render() {
    const { product } = this.props
    const { type } = this.props
    const finanziamentoH1 = 'Inserisci i tuoi dati e richiedi il finanziamento!'
    const finanziamentoFindomesticH1 =
      'Inserisci i tuoi dati e richiedi il finanziamento Findomestic!'
    const bankH1 = 'Inserisci i tuoi dati e completa il passaggio di proprietà!'
    const noleggioH1 =
      'Inserisci i tuoi dati e richiedi il noleggio a lungo termine!'

    const valoriLogistica =
      type === 'bank' ||
      (type === 'noleggio' && isNltBrumbrum(this.props.product)) ||
      type === 'finanziamento' ||
      type === 'finanziamento_findomestic'
        ? preparaValoriLogistica(this.props.pricing.total, this.props.logistica)
        : {}

    return (
      <section className="relative process">
        <div className="process__header">
          <h1 className="process__title">
            {type === 'bank' && bankH1}
            {type === 'finanziamento' && finanziamentoH1}
            {type === 'finanziamento_findomestic' && finanziamentoFindomesticH1}
            {type === 'noleggio' && noleggioH1}
          </h1>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className="user-informations">
          <div className="container_small">
            <div className="process__column process__column__left">
              {type === 'bank' && (
                <BuyDataFormBank helper={this.handleHelper} />
              )}
              {type === 'bank' && (
                <BuyHelpBank
                  helper={this.handleHelper}
                  show={this.props.help}
                />
              )}
              {type === 'finanziamento' && (
                <BuyDataFormFinancement helper={this.handleHelper} />
              )}
              {(type === 'finanziamento' ||
                type === 'finanziamento_findomestic') && (
                <BuyHelpFinancement
                  helper={this.handleHelper}
                  show={this.props.help}
                />
              )}
              {type === 'noleggio' ? (
                isNltBrumbrum(this.props.product) ? (
                  <NoleggiaBrumbrumDataForm helper={this.handleHelper} />
                ) : (
                  <NoleggiaDataForm helper={this.handleHelper} />
                )
              ) : null}
              {type === 'finanziamento_findomestic' && (
                <BuyDataFormFindomestic helper={this.handleHelper} />
              )}
            </div>
            <div className="process__column process__column__right">
              {type === 'finanziamento' ||
              type === 'finanziamento_findomestic' ||
              type === 'bank' ? (
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={getSelectedFinanziamento(
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={this.props.type}
                  price={this.props.ordine.auto_prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              ) : null}
              {type === 'noleggio' && (
                <MiniCartNlt
                  {...valoriLogistica}
                  nlt={this.props.nlt}
                  product={product}
                  ui={this.props.ui}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

Data.defaultProps = {
  comuni: {
    comune: [],
    nazioni: [],
  },
}

Data.propTypes = {
  buyHelper: PropTypes.func,
  compass_tabelledominio: PropTypes.object,
  comuni: PropTypes.object,
  customer: PropTypes.object,
  getComuni: PropTypes.func,
  getNazioni: PropTypes.func,
  getTabelleDominioCompass: PropTypes.func,
  getTabelleDominioCompassCallbackCittadinanza: PropTypes.func,
  help: PropTypes.bool,
  logistica: PropTypes.object,
  newComuni: PropTypes.func,
  newNazioni: PropTypes.func,
  nlt: PropTypes.object,
  ordine: PropTypes.object,
  financements: PropTypes.object,
  pricing: PropTypes.object,
  product: PropTypes.object,
  reroute: PropTypes.func,
  type: PropTypes.string,
}

const mapStateToProps = state => ({
  compass_tabelledominio: state.compass_tabelledominio,
  comuni: state.comuni,
  customer: state.customer,
  help: state.ui.buyHelper,
  logistica: state.logistica,
  financements: state.financements,
  nlt: state.nlt,
  ordine: state.ordine,
  pricing: state.pricing,
  product: state.product,
  type: state.payment.method,
  ui: state.ui,
})

const mapDispatchToProps = {
  buyHelper,
  getComuni,
  getNazioni,
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackCittadinanza,
  newComuni,
  newNazioni,
  reroute,
}

export default connect(mapStateToProps, mapDispatchToProps)(Data)
